export const POSTS_PER_PAGE = 9;

export const getBlogPagePath = ({ categorySlug = null, page = 1 }) => {
  if (categorySlug) {
    return page <= 1
      ? `/blog/categorie/${categorySlug}/`
      : `/blog/categorie/${categorySlug}/page/${page}/`;
  }

  return page <= 1 ? `/blog/` : `/blog/page/${page}/`;
};

export const getBlogPaginationPaths = ({
  categorySlug = null,
  currentPage,
  totalPages,
}) => {
  return {
    previousPagePath:
      currentPage > 1
        ? getBlogPagePath({ categorySlug, page: currentPage - 1 })
        : null,
    nextPagePath:
      currentPage < totalPages
        ? getBlogPagePath({ categorySlug, page: currentPage + 1 })
        : null,
  };
};
